import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, PositiveMonetaryValue } from '../fields';

export const RecordHoldbackDrawDisbursementRow = z.object({
  loanId: LosId,
  disbursementType: z.enum(['holdbackDraw']),
  disbursementDate: DateString,
  disbursementTotal: PositiveMonetaryValue,
  note: z.string().optional(),
});
export type RecordHoldbackDrawDisbursementRow = z.infer<typeof RecordHoldbackDrawDisbursementRow>;

export const RECORD_HOLDBACK_DRAW_DISBURSEMENT_ROW_REQUIRED_FIELDS = Object.keys(
  RecordHoldbackDrawDisbursementRow.shape,
).filter(
  (key) =>
    !RecordHoldbackDrawDisbursementRow.shape[key as keyof typeof RecordHoldbackDrawDisbursementRow.shape].isOptional(),
);
